<template>
  <div class="navbar">
    <ul class="navitems">
      <li
        @click="handleNavClick('/plans/select')"
        :class="{ active: $route.path.indexOf('plans') > 0 }"
      >
        <i class="far fa-calendar-alt"></i>
        Audit an EHCP
      </li>
      <li
        v-if="canViewItem('admin')"
        @click="handleNavClick('/reports/dashboard')"
        :class="{ active: $route.path.indexOf('reports') > 0 }"
      >
        <i class="far fa-clipboard"></i>
        Reports
      </li>
      <li
        v-if="canViewItem('admin')"
        @click="handleNavClick('/admin/users')"
        :class="{ active: $route.path.indexOf('admin') > 0 }"
      >
        <i class="fas fa-database"></i>
        Coordinator
      </li>
      <li
        @click="handleNavClick('/support')"
        :class="{ active: $route.path.indexOf('support') > 0 }"
      >
        <i class="far fa-life-ring"></i>
        Support
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TopNav',
  computed: {
    ...mapGetters({ role: 'user/role' })
  },
  methods: {
    canViewItem (resource) {
      switch (resource) {
        case 'admin':
          return !!['manage', 'admin', 'super'].includes(this.role)
        case 'reports':
          return !!['report', 'manage', 'admin', 'super'].includes(this.role)
        case 'super':
          return !!['super'].includes(this.role)
        default:
          return true
      }
      // if (resource === 'admin' || resource === 'reports') {
      //   return this.role !== 'audit'
      // } else if (resource === 'super') {
      //   return this.role === 'super'
      // }
      // return true
    },
    handleNavClick (item) {
      this.$router.push(item)

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/nav.scss';

li {
  color: lightgrey;
}
</style>
